import {
    GESTION_OPERATIVA_CALCULATE_REMAINING_BEGIN,
} from '../constants';

export function calculateRemaining( body ) {
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_CALCULATE_REMAINING_BEGIN,
            data: body
        })
    }
}